import React, { Component } from "react";
import { Waypoint } from "react-waypoint";

import Player from "../Player/Player";
import Expander from "../Expander/Expander";
import Lock from "../Lock/Lock";

import "./styles.scss";

class ChapterFive extends Component {
  constructor(props) {
    super(props);
    this.state = { width: 0, height: 0 };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }
  componentDidMount() {
    this.props.scrollToActive && this.props.scrollToActive("five");
    this.updateWindowDimensions();
  }
  render() {
    function smsDialog() {
      setTimeout(function () {
        document.getElementById("sms-one").style.opacity = "1";
        setTimeout(function () {
          document.getElementById("sms-two").style.opacity = "1";
          setTimeout(function () {
            document.getElementById("sms-three").style.opacity = "1";
          }, 2000);
        }, 2000);
      }, 1000);
    }
    return (
      <>
        <Waypoint
          horizontal
          onEnter={() => {
            this.props.chapterTransition("five");
          }}
        >
          <div className="chapter chapter-five chapter-5"style={{height: this.state.height + "px" }}>
            <div className="scroll-container bg-back">
              <div className="scroll"></div>
            </div>
            <div className="scroll-container bg-middle">
              <div className="scroll scroll-two"></div>
            </div>
            <div className="scroll-container bg-solid">
              <div className="scroll"></div>
            </div>
            <div className="scroll-container mushroom">
              <div className="scroll"></div>
            </div>
            <div className="scroll-container mushroom-mac">
              <div className="scroll"></div>
            </div>
            <div className="scroll-container one">
              <div className="green-content scroll">
                <h2>Visste du at vi bare ser litt av soppen?</h2>
                <p>
                  Under bakken har all sopp noe som ligner på nettet til
                  Spiderman, <b>sopptråder</b>, og disse er kjempeviktige for de
                  andre artene i skogen. Trådene kan for eksempel frakte viktige
                  næringsstoffer mellom trær og andre planter. Soppen er også en
                  slags superhelt!
                </p>
              </div>
              <Player file="5_1" />
            </div>
            <div className="scroll-container two">
              <div className="white-content scroll">
                <p>
                  Sopptrådene hjelper arter med å snakke sammen, og er litt som
                  naturens internett. Derfor kaller forskere det{" "}
                  <b>Wood Wide Web</b>.
                </p>
              </div>
              <Player file="5_2" />
            </div>
            <div id="sms-one" className="scroll-container three">
              <Waypoint
                horizontal
                onEnter={() => {
                  smsDialog();
                }}
              />
              <div className="icon"></div>
              <div className="white-content scroll">
                <p>Trenger litt næring. Sender du over noe sukker?</p>
              </div>
              <Player file="5_3" />
            </div>
            <div id="sms-two" className="scroll-container four">
              <div className="white-content scroll">
                <p>Sender med soppen nå, kompis!</p>
              </div>
              <div className="icon"></div>
              <Player file="5_4" />
            </div>
            <div id="sms-three" className="scroll-container five">
              <div className="icon"></div>
              <div className="white-content scroll">
                <p>Tommel sopp, du er helt kongle!</p>
              </div>
              <Player file="5_5" />
            </div>
            <div className="thank-you">
              Takk for at du skyller, bretter og stapper skolemelka for soppen!
            </div>
            <Expander
              class="expander-one"
              content="Visste du at verdens største levende organisme er en sopp? Den lever i Nord Amerika og brer seg over et området som er større enn 1300 fotballbaner."
              chapter='5'
            ></Expander>
            <Lock progress="six" handleModal={this.props.handleModal}></Lock>
          </div>
        </Waypoint>
      </>
    );
  }
}
export default ChapterFive;
